export default "__VITE_ASSET__ogYDnHSZ__"